import { MESSAGE_CONDITION_OPERATORS, MESSAGE_VARIABLES } from '@repo/lib';

const VARIABLE_IDS = MESSAGE_VARIABLES.map(({ id, label }) => `\`${id}\` (${label})`).join(', ');

export const MESSAGE_VARIABLES_HELP =
  "Write `{{id}}` where a customer's own details go, and it is filled in for each customer: `{{field_<field id>}}` for their answer to one of the page's fields, `{{variant_<variant id>}}` and `{{variant_<variant id>_sku}}` for their variant choice, or one of " +
  `${VARIABLE_IDS}. ` +
  'Product, variant, license key and billing variables apply to checkout pages, event variables to events, `form_title` to forms; a variable that does not apply is left blank. ' +
  'To show paragraphs only to some customers, wrap them in `<if variable="<id>" operator="<operator>" value="<value>">...</if>`, with operator one of ' +
  `${MESSAGE_CONDITION_OPERATORS.join(', ')}.`;

export const MESSAGE_VARIABLES_OUTPUT_HELP =
  'Variables read as `{{id}}` and conditional paragraphs as `<if variable="..." operator="..." value="...">` blocks; send them back unchanged to keep them.';
